module.exports = __webpack_public_path__ + "static/191014-BS-IGB-F1-Lobby-WC-2019-Stream-Giveaway-a3e0897b64198c43b5c40cd657efeaa3.jpg";